import React from "react";
import $ from "jquery";
import {
    getFromLocalStorage,
    sendToLocalStorage,
    removeNestedNullUndefined,
    capitalize, strstr
} from './Utilities';

class FilterButton extends React.Component{

    handleClick = () => {
        window.location.href = window.location.origin+"/dashboard/reports#"+this.props.Link;
    }

    render(){
        return (
            <button onClick={this.handleClick} type="button" 
                className="btn btn-outline-secondary waves-effect waves-light mr-10 mb-2" data-href={this.props.Link}
                dangerouslySetInnerHTML={{__html: this.props.Text}} >
            </button>
        );
    }
}

class ReportsCriteria extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            "data": {},
            "filters": {},
            "dataReady": false
        };
    }

    getOtherCriteriaFields(){
        return ['Channels', 'Country', 'Age', 'Gender', 'Score', 'Keyword'];
    }

    componentDidMount() {       
        var data = this.props?.values || $("#SessionReportFilters").data('reportFilters');//on results page we get values from markup instead
        if(!data) data = getFromLocalStorage("report_data");//if still no data get directly from local storage

        this.setState({
            data: data
        });  
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.state.data && Object.keys(this.state.data).length > 0 && !this.state.dataReady) {
            this.setState({
                dataReady: true
            });
          
            this.generateCriteriaSoFar();
        }
    }

    generateCriteriaSoFar(){
        // console.log("generating report criteria");
  
        var data = this.state.data;
        var filters = [];

        if(data.ReportType) {
            filters[0] = {};
            var parts = data.ReportType.split('-');
            var niceName = capitalize(parts[0])+capitalize(parts[1]).trim();
            filters[0]["Text"] = "<strong>Report:</strong>"+niceName;
            filters[0]['Link'] = "ReportType";
        }
        if(data.ChooseBrands && Object.keys(data.ChooseBrands).length > 0) {
            filters[1] = {};
            filters[1]['Text'] = (data.ChooseBrands.length > 1) ? "<strong>Brands:</strong>" : "<strong>Brand:</strong>";
            var brands = [];
            $(Object.values(data.ChooseBrands)).each(function(k, brand){
                brands[k] = brand['Name'];
            });
            filters[1]['Text'] += " "+brands.join(", ");
            filters[1]['Link'] = "ChooseBrands";
        }
        if(data.ChooseActivities){
            var link = "ChooseActivities";
            
            if(data.ChooseActivities.Segment && Object.keys(data.ChooseActivities.Segment).length > 0){
                filters[2] = {};
                filters[2]['Text'] = "<strong>Segment:</strong> "+data.ChooseActivities.Segment.Name;
                filters[2]['Link'] = link;
            }
            if(data.ChooseActivities.AnyOf && Object.keys(data.ChooseActivities.AnyOf).length > 0) {
                var anyof_text = [];
                var anyof_count = 0;
                $(Object.values(data.ChooseActivities.AnyOf)).each(function(k, activity){
                    anyof_text[k] = activity['Name'];
                    anyof_count++;
                });
                var anyof_label = (parseInt(anyof_count) === 1) ? "Must have" : "Must have either";

                filters[3] = {};
                filters[3]['Text'] = "<strong>"+anyof_label+":</strong> "+anyof_text.join(" or "); 
                filters[3]['Link'] = link;
            }
            if(data.ChooseActivities.AllOf && Object.keys(data.ChooseActivities.AllOf).length > 0) {
                var allof_text = [];
                var allof_count = 0;
                $(Object.values(data.ChooseActivities.AllOf)).each(function(k, activity){          
                    allof_text[k] = activity['Name'];
                    allof_count++;
                });
                var allof_label = (parseInt(allof_count) === 1) ? "Must have" : "Must have all of";

                filters[4] = {};
                filters[4]['Text'] = "<strong>"+allof_label+":</strong> "+allof_text.join(" and ");
                filters[4]['Link'] = link;
            }
            if(data.ChooseActivities.NoneOf && Object.keys(data.ChooseActivities.NoneOf).length > 0) {
                var noneof_text = [];
                var noneof_count = 0;
                $(Object.values(data.ChooseActivities.NoneOf)).each(function(k, activity){           
                    noneof_text[k] = activity['Name'];
                    noneof_count++;
                });
                var noneof_label = (parseInt(noneof_count) === 1) ? "Must not have" : "Must not have any of";

                filters[5] = {};
                filters[5]['Text'] = "<strong>"+noneof_label+":</strong> "+noneof_text.join(" or ");
                filters[5]['Link'] = link;
            }
        }
        if(data.DateRange && Object.keys(data.DateRange).length > 0){
            filters[6] = {};
            filters[6]["Text"] = "<strong>Date range:</strong>"+data.DateRange.replace("+", " ").toLowerCase();
            var rangeRegex = /(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[1,2])\/(19|20)\d{2}/; //checks if date range (eg. 14/08/2024)
            if(!data.DateRange.match(rangeRegex)) filters[6]["Text"] += "s";//if not of type date range ie period, add "s"
            filters[6]['Link'] = "DateRange";
        }
        if(data.OtherCriteria){
            var filterIndex = 7;
            $(this.getOtherCriteriaFields()).each(function(k, criteria){
                //only write criteria for populated fields
                var createFilter = false;       
                if($.isArray(data.OtherCriteria[criteria])){
                    if(Object.keys(data.OtherCriteria[criteria]).length > 0) createFilter = true;   
                } else {
                    if(data.OtherCriteria[criteria]) createFilter = true;
                }

                if(createFilter){
                    filters[filterIndex] = {};
                    if(criteria === "Channels"){
                        var channels = data.OtherCriteria[criteria][0];
                        var channel_label = (parseInt(channels.length) === 1) ? "Channel" : "Channels";
                        channels = channels.join(", ");
                        channels = channels.replaceAll("Authenticator", "");
                        filters[filterIndex]["Text"] = "<strong>"+channel_label+":</strong>"+channels;
                    } else if (criteria === "Country"){   
                        var countries = data.OtherCriteria[criteria][0];
                        var country_label = (parseInt(countries.length) === 1) ? "Country" : "Countries";
                        countries = countries.join(', ');
                        filters[filterIndex]["Text"] = "<strong>"+country_label+":</strong>"+countries;
                    } else {
                        filters[filterIndex]["Text"] = "<strong>"+criteria+":</strong>"+data.OtherCriteria[criteria];
                    }
                    filters[filterIndex]['Link'] = "OtherCriteria";
                    filterIndex++;
                }
            });
        } 
        if(data.Application){
            if(!data.Application?.Default) {
                filters[8] = {};
                filters[8]['Text'] = "<strong>Application:</strong> "+data.Application.Name;
                filters[8]['Link'] = "ChooseActivities";
            }
        }

        this.setState({
            'filters': filters
        });
    }

    render() {
        const filters = removeNestedNullUndefined(this.state.filters); //removes empty values

        if(Object.keys(filters).length > 0){
            return(
                <div className="criteria-inner">
                    {Object.entries(this.state.filters).map(function(obj, key){
                       return <FilterButton key={obj[1].Text+key} Text={obj[1].Text} Link={obj[1].Link} />
                    })}
                </div>
            );
        } else {
            return(
                <div className="criteria-inner">
                    <div className="react-loading horizontal"></div>
                </div>    
            );
        }
    }
}

export default ReportsCriteria;

